import { render, staticRenderFns } from "./CalculationPage.vue?vue&type=template&id=33edb128&scoped=true&"
import script from "./CalculationPage.vue?vue&type=script&lang=ts&"
export * from "./CalculationPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33edb128",
  null
  
)

export default component.exports